// Función para cargar libs.min.js primero
export const loadLibsScript = () => {
    return new Promise((resolve, reject) => {
        // Verificar si ya está cargado y GSAP está disponible
        if (window.gsap) {
            console.log('[Scripts] GSAP already loaded');
            // Configurar GSAP para suprimir warnings
            if (window.gsap.config) {
                window.gsap.config({
                    nullTargetWarn: false,
                    trialWarn: false
                });
            }
            resolve();
            return;
        }

        const libsLoaded = document.querySelector('script[src*="libs.min.js"]');

        if (libsLoaded) {
            // Si el script existe pero GSAP no está disponible aún, esperar
            const checkGSAP = setInterval(() => {
                if (window.gsap) {
                    clearInterval(checkGSAP);

                    // Configurar GSAP para suprimir warnings
                    if (window.gsap.config) {
                        window.gsap.config({
                            nullTargetWarn: false,
                            trialWarn: false
                        });
                    }

                    console.log('[Scripts] GSAP loaded (from existing script)');
                    resolve();
                }
            }, 50);

            // Timeout de seguridad
            setTimeout(() => {
                clearInterval(checkGSAP);
                if (!window.gsap) {
                    console.warn('[Scripts] GSAP timeout - forcing reload');
                    libsLoaded.remove();
                    loadLibsScript().then(resolve).catch(reject);
                }
            }, 5000);
            return;
        }

        console.log('[Scripts] Loading libs.min.js...');
        const libsScript = document.createElement('script');
        libsScript.src = '/js/libs.min.js';
        libsScript.async = false; // Importante: no async para mantener orden

        libsScript.onload = () => {
            // Esperar a que GSAP esté disponible
            const checkGSAP = setInterval(() => {
                if (window.gsap) {
                    clearInterval(checkGSAP);

                    // Configurar GSAP para suprimir warnings de targets no encontrados
                    if (window.gsap.config) {
                        window.gsap.config({
                            nullTargetWarn: false,
                            trialWarn: false
                        });
                    }

                    console.log('[Scripts] libs.min.js loaded successfully');
                    resolve();
                }
            }, 50);

            // Timeout de seguridad
            setTimeout(() => {
                clearInterval(checkGSAP);
                if (window.gsap) {
                    resolve();
                } else {
                    console.error('[Scripts] GSAP not available after loading');
                    reject(new Error('GSAP not available'));
                }
            }, 2000);
        };

        libsScript.onerror = (error) => {
            console.error('[Scripts] Error loading libs.min.js:', error);
            reject(error);
        };

        document.head.appendChild(libsScript);
    });
};

// Función para cargar app.js después de libs.min.js
export const loadAppScript = () => {
    return new Promise((resolve, reject) => {
        const appLoaded = document.querySelector('script[src*="app.js"]');

        if (appLoaded && window.templateInitialized) {
            console.log('[Scripts] app.js already loaded');
            resolve();
            return;
        }

        // Si existe pero no está inicializado, removerlo
        if (appLoaded) {
            appLoaded.remove();
        }

        console.log('[Scripts] Loading app.js...');
        const appScript = document.createElement('script');
        appScript.src = '/js/app.js';
        appScript.async = false; // Importante: no async para mantener orden

        appScript.onload = () => {
            window.templateInitialized = true;
            console.log('[Scripts] app.js loaded successfully');
            resolve();
        };

        appScript.onerror = (error) => {
            console.error('[Scripts] Error loading app.js:', error);
            reject(error);
        };

        document.body.appendChild(appScript); // Añadir al body en lugar del head
    });
};

// Función principal para cargar scripts en orden
export const loadTemplateScripts = async () => {
    try {
        console.log('[Scripts] Starting template scripts loading...');

        // Cargar libs.min.js primero
        await loadLibsScript();
        console.log('[Scripts] libs.min.js ready');

        // Esperar un poco para asegurar que GSAP esté completamente inicializado
        await new Promise(resolve => setTimeout(resolve, 200));

        // Verificar que GSAP realmente esté disponible
        if (!window.gsap) {
            throw new Error('GSAP not available after loading libs.min.js');
        }

        // Cargar app.js después
        await loadAppScript();
        console.log('[Scripts] All scripts loaded successfully');

    } catch (error) {
        console.error('[Scripts] Error loading template scripts:', error);
        throw error;
    }
};

// Función simple para inicializar efectos del template
export const initializeTemplateEffects = () => {
    // Template original maneja todo
};

// Función principal para inicializar todo
export const initializeTemplate = async () => {
    try {
        await loadTemplateScripts();
    } catch (error) {
        // Error silencioso
    }
};